import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import AddSubAdminPageNew from "../../components/SubAdmin/AddSubAdminPageNew";



const AddSubAdminPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb  id="title" title2="Sub Admin" link2="/subadmin" title="Add Sub Admin" />

        {/* AddUserLayer */}
        <AddSubAdminPageNew />


      </MasterLayout>
    </>
  );
};

export default AddSubAdminPage;
